export default {
    WorkorderType: {
        Workorderservicetype: 'Ticket Type',
        Addwork:"Add Ticket Type",
        table: {
            WorkorderText:"Ticket Type Code",
            ServiceType:"Service",
            TypeErrordescription:"Ticket Description",
            Feeitems:"Charge Items",
            attachments:"Attachment Required",
            InquiryType: 'Department',
            Updatetime:"Last Updated Time",
            Updateperson:'Updated By',
        },
    },
    workOrderList:{
        TicketInformation: 'Ticket Information',
        step1: 'Submit',
        step2: 'Approve',
        step3: 'In Process',
        step4: 'Confirm',
        WOTitle:'Ticket Title',
        Urgent:'Urgency Level',
        WOSubmit:'Submit For Approval',
        Approval:'Approval',
        Start:'Start Processing',
        Pause:'Pause Processing',
        Complete:'Complete Processing',
        to:'Cancel',
        Confirm:'Confirm Charges',
        processor:'Change Assignee',
        Modify:'Modify Customer Service',
        Number:'Ticket ID',
        service:'Service',
        title:'Title',
        Description:'Service Description',
        type:'Associated Object',
        quantity:'Quantity Processed',
        state:'Status',
        Do:'Paused',
        Creation:'Creation Time',
        Review:'Approval Time',
        editTime:'Edit Estimated Time',
        Completion:'Completion Time',
        CompletionTime:'Expected Completion Time',
        Submit:'Ticket',
        Processing:'Assignee',
        Work:'Ticket Description',
        enclosure:'Attachment',
        Related:'Associated Object',
        bar:'Barcode',
        results:'Result',
        Ticket:'Ticket Reply',
        findings:'Approval Result',
        Reason:'Rejection Reason',
        Total:'Working Duration (minutes)',
        Fee:'Charge List',
        Operations:'Processing Department',
        Customer:'Customer Service',
        Operator:'Operator',
        timeS:'Expected Start Time',
        timeE:'Expected End Time',
        typeTitle:'Relevant Categories',
        auditTitle:'Departmental Approval',
        customerTitle:'Customer Service Confirmation',
        Comments:'Comments Box',
        DepartmentText:'Designated Department',
    }
  };
  